import React from 'react';
import {connect} from 'react-redux';
import {cloneDeep, sortBy, startCase, get} from 'lodash';
import {Link} from "react-router-dom";
import * as preconfiguredInputs from '../../../utils/forms/preconfiguredInputs'
// local imports
import api from '../../../store/api'
import AdminWrapper from "../../theme/wrappers/AdminWrapper";
import Input from "../../theme/forms/Input";
import BaseForm from "../../theme/forms/BaseForm";
import BaseModal from "../../theme/modals/BaseModal"
import PaginatedTable from "../../theme/tables/PaginatedTable";
import ConfirmModal from "../../theme/modals/ConfirmModal";
import FormModal from "../../theme/modals/FormModal";
import SearchAndSelectModal from "../../theme/modals/SearchAndSelectModal";
import SelectByCategory from "../../theme/forms/SelectByCategory";
import {addErrorAlert, toggleGlobalLoader} from "../../../store/calls/alertLoadingDispatch";
import NoResultsBox from "../../theme/cards/NoResultsBox";


import {pullStates} from "../../../store/calls"
import validators from "../../../utils/forms/validators";
import MapFrame from "../../theme/maps/mapFrame";
import formatters from "../../../utils/forms/formatters";
import {displaySummaryData} from "../../../utils/displayData";
import ItemTextEditModal from "../../theme/modals/ItemTextEditModal";
import {getUUID} from "../../../utils/hashFuncs";

/*
  NOTE TO SELF:

  TOP IS A CARD, NAME OF PROGRAM AND SPECIFICATIONS, ALLOWS YOU TO EDIT.
  BELOW IS A TABLE. SAME TABLE AS THE OTHER ONES, WHICH ALLOWS YOU TO EDIT.

  I ALSO NEED TO BUILD A SEARCH FUNCTION THAT WILL ALLOW YOU TO ADD OR REMOVE DISTRICTS OR IMPROVEMENTS TO THIS.
*/

class PaceProgramSpecScreen extends React.Component {

  constructor(props) {
    super(props);

    this.state = {

      displayedData: [],
      displayedColumns: [],
      dataPullLimit: 25,
      dataPullOffset: 0,

      specInstance: {}, // the actual pace program thing that is the focus of the spec page. Pulled by ID from URL.

      // edit and delete
      editModalOpen: false,
      deleteModalOpen: false,

      deleteDistrictPaceProgramModalOpen: false,
      addDistrictPaceProgramModalOpen: false,
      districtAdditionSearchResults: [],

      deletePaceProgramImprovementModalOpen: false,
      improvementList: [],
      changedImprovements: false,


      editingInstance: null,
      mode: 'communities', // can also be improvements
      categoryFilter: null,
      nameFilter: null,

      exceptionModalOpen: false,
      displayMap: false,

      // funders and products
      productModalOpen: false,
      productsData: [],

    }

    // working default
    this.defaultGeojson = {
      "type": "FeatureCollection",
      "features": [
        {
          "type": "feature",
          "geometry": {
            "type": "MultiPolygon",
            "coordinates": []
          }
        }
      ]
    }

    this.mapGeojson = this.defaultGeojson;

    this.specInstanceId = props.match.params.id;

    this.baseAPIPath = '/pace-programs/' + this.specInstanceId + '/';


    this.editSpecInstanceInputs = [
      {
        type: 'text',
        label: "Name*",
        dataKey: "name",
        ...validators.isStringOfMinLength(3)
      },
      {
        type: 'textarea',
        label: "Description",
        dataKey: "description",
      },
      {
        type: 'select',
        label: "State*",
        dataKey: "state",
        options: sortBy(this.props.states, ['name']).map(d => ({value: d.id, display: d.name})),
        ...validators.exists,
      },
      {
        type: 'text',
        label: "Program Minimum",
        subLabel: "The smallest project this program will accept, in dollars",
        dataKey: "program_minimum",
        ...validators.isNumber,
        ...formatters.USDCurrency,
      },
      {
        type: 'text',
        label: "Program Maximum",
        subLabel: "The largest project this program will accept, in dollars",
        dataKey: "program_maximum",
        ...validators.isNumber,
        ...formatters.USDCurrency,
      },
      {
        type: 'textarea',
        label: "Property Tax Delinquency Policy",
        dataKey: "prop_tax_delinquency_policy",
      },
      {
        type: 'textarea',
        label: "Bankruptcy Policy",
        dataKey: "bankruptcy_policy",
      },
      {
        type: 'text',
        label: "Program Fee Tier 1",
        dataKey: "program_fee_tier_1",
        // ...validators.isNumber,
        otherInputs: [
          {
            ...preconfiguredInputs.flatFeeChargeTypeSelect,
            dataKey: "program_fee_tier_1_charge_type",
            label: "Charge Type"
          },
          {
            type: "text",
            dataKey: "program_fee_tier_1_cost_ceiling",
            label: "Tier 1 Cieling (leave blank if none)",
            placeholder: "tier cieling",
            // ...validators.isNumber,
            ...formatters.USDCurrency
          }
        ]
      },
      {
        type: 'text',
        label: "Program Fee Tier 2",
        dataKey: "program_fee_tier_2",
        // ...validators.isNumber,
        otherInputs: [
          {
            ...preconfiguredInputs.flatFeeChargeTypeSelect,
            dataKey: "program_fee_tier_2_charge_type",
            label: "Charge Type"
          },
          {
            type: "text",
            dataKey: "program_fee_tier_2_cost_ceiling",
            label: "Tier 2 Cieling (leave blank if none)",
            placeholder: "tier cieling",
            // ...validators.isNumber,
            ...formatters.USDCurrency
          }
        ]
      },
      {
        type: 'text',
        label: "Program Fee Tier 3",
        dataKey: "program_fee_tier_3",
        // ...validators.isNumber,
        otherInputs: [
          {
            ...preconfiguredInputs.flatFeeChargeTypeSelect,
            dataKey: "program_fee_tier_3_charge_type",
            label: "Charge Type"
          },
        ]
      },
      {
        type: 'text',
        label: "Program Fee Min/Max",
        dataKey: "program_fee_minimum",
        placeholder: "Minimum",
        // ...validators.isNumber,
        ...formatters.USDCurrency,
        otherInputs: [
          {
            type: "text",
            dataKey: "program_fee_maximum",
            placeholder: "Maximum",
            // ...validators.isNumber,
            ...formatters.USDCurrency
          },
        ]
      },
      {
        type: 'select',
        label:  "Program Fee Cost Basis",
        dataKey: 'program_fee_cost_basis',
        options: [
          {
            value: "financed_amount",
            display: "Financed Amount"
          },
          {
            value: "cost_of_improvements",
            display: "Cost of Improvements"
          },
        ]
      },
      {
        type: 'text',
        label: "Program Annual Fee",
        dataKey: "annual_fee",
        // ...validators.isNumber,
        otherInputs: [
          {
            ...preconfiguredInputs.flatFeeChargeTypeSelect,
            dataKey: "annual_fee_type",
            label: "Charge Type"
          },
        ]
      },
      {
        type: 'text',
        label: "Proof of Saving or Efficiency Policy",
        dataKey: "proof_of_savings_req",
      },
      {
        ...preconfiguredInputs.nullBooleanSelect,
        label: "Do Funders Bill Directly",
        dataKey: "allow_direct_funder_billing",
      },
      {
        type: 'text',
        label: "First Payment Due Date (M/DD, eg, 3/01) *",
        dataKey: "first_payment_due_date",
        // ...validators.isStringOfMinLength(4),
        ...formatters.date("Mdd",  "LLLL dd"),
      },
      {
        type: 'text',
        label: "State or County Fiscal Year End (M/DD, eg, 3/01) *",
        dataKey: "fiscal_year_end",
        // ...validators.isStringOfMinLength(4),
        ...formatters.date("Mdd",  "LLLL dd"),
      },
      {
        type: 'text',
        label: "Number of payments billed per year",
        dataKey: "prop_tax_annual_payment_count",
        ...validators.isNumber
      },
      {
        type: 'text',
        label: "Min Number of Units in Commercial Multi Family Projects*",
        dataKey: "multi_family_min_units",
        ...validators.isNumber
      },
      {
        ...preconfiguredInputs.nullBooleanSelect,
        label: "Lender Consent Required",
        dataKey: "lender_consent_req",
      },
      {
        ...preconfiguredInputs.nullBooleanSelect,
        label: "Accept Refinance",
        dataKey: "refi_ok",
      },
      {
        type: "text",
        label: "Maximum aging (in years) of an authorized improvement to be refinanced",
        dataKey: "refi_lookback_period",
        ...validators.isNumber
      },
      {
        ...preconfiguredInputs.nullBooleanSelect,
        label: "Is a permitted building required on the parcel to qualify?",
        dataKey: "permitted_building_required",
      },
      {
        type: "textarea",
        label: "Other Notes",
        dataKey: "other_notes",
      }

    ]

  }

  componentDidMount() {
    toggleGlobalLoader(true);

    Promise.all([
      this.getData(),
      this.getProducts(),
      this.getImprovementsForAddition(),
    ])
      .then(() => this.changeMode('communities'))
      .catch(() => null)
      .then(() => toggleGlobalLoader(false))

    pullStates();

  }

  toggleEditModal = () => {
    this.setState({editModalOpen: !this.state.editModalOpen})
  }

  getData = (xtraParams = {}) => {

    return api.get(this.baseAPIPath)
      .then(res => {
        this.setState({specInstance: res.data})
      })
      .catch(() => addErrorAlert('Data Pull Failed.'))
  }

  getDistrictsForAddition = (searchParam) => {
    let params = {limit: 100, name: searchParam, state: this.state.specInstance.state_id}

    return api.get('/districts/', params)
      .then(res => {
        this.setState(
          {
            districtAdditionSearchResults:
              res.data.results.map(d => ({
                ...d,
                added: this.state.displayedData.filter(d => d.district).map(d => d.district.id).includes(d.id)
              }))
          })
      })
      .catch(() => addErrorAlert('Failed to pull all districts.'))
  }

  getImprovementsForAddition = () => {
    return api.get('/improvements/',{cacheBust: getUUID()})
      .then(res => {
        this.setState({
          improvementList: res.data
        })
      })
      .catch(() => addErrorAlert('Failed to pull improvements.'))
  }

  getProducts = () => {
    return api.get('/loan-products/')
      .then(res => this.setState({productsData: res.data}))
  }

  populateSpecInstanceInputsWithValues = () => {

    return this.editSpecInstanceInputs.map(d => {
      if (d.dataKey === 'state') {
        return {...d, value: this.state.specInstance.state_id}
      } if (d.otherInputs && d.otherInputs.length) {
        return {
          ...d, value: this.state.specInstance[d.dataKey],
          otherInputs: d.otherInputs.map(item => ({...item, value: this.state.specInstance[item.dataKey]}))
        }
      } 
        return {
          ...d,
          value: this.state.specInstance[d.dataKey]
        }
      
    })
  }

  handleDistrictPaceProgramDeleteRequest = (id, district_id, pull_data = true) => {
    api.delete('/district-pace-programs/' + id)
      .then(() => this.setState({
        editingInstance: null,
        deleteDistrictPaceProgramModalOpen: false,
        districtAdditionSearchResults: this.state.districtAdditionSearchResults.map(d => d.id === district_id ? {
          ...d,
          added: false
        } : d)
      }))
      .then(() => pull_data ? this.getData().then(() => this.changeMode('communities')) : () => {
      })
  }

  handleDistrictPaceProgramCreateRequest = (district_id, include_child_districts) => {
    let request = {district: district_id, pace_program: this.specInstanceId};
    if (include_child_districts) request.all_child_districts_included = true;
    api.post('/district-pace-programs/', request)
      .then(() => this.setState({
        districtAdditionSearchResults: this.state.districtAdditionSearchResults.map(d => d.id === district_id ? {
          ...d,
          added: true
        } : d)
      }))
  }

  handleDistrictPaceProgramPatchRequest = (dpp_id, district_id, data) => {

    api.patch(`/district-pace-programs/${dpp_id}/`, {...data})
      .then((res) =>
        this.setState({
          specInstance: {
            ...this.state.specInstance,
            pace_programs: this.state.specInstance.districts
              .map(p => p.id === dpp_id ? {...p, ...data} : p)
          }
        }))
      .catch(() => addErrorAlert('Failed to update the district pace program.'));

  }

  handleDeleteRequest = () => {
    api.patch(this.baseAPIPath, {is_active: 0})
      .then(() => window.location = '/admin/pace-programs/')
      .catch(() => addErrorAlert('Failed to delete.'))
  }


  handleUpdateRequest = (data) => {
    // console.log("fire update")
    return api.patch(this.baseAPIPath, data)
      .then(() => this.getData())
      .catch(() => addErrorAlert('Failed to update.'))
      .finally(() => this.setState({editModalOpen: false, editingInstance: null}))

  }


  handleSearch = (val) => {
    this.setState({nameFilter: val},
      this.getData
    )
  }

  handlePaceProgramImprovementCreateRequest = (improvement_id) => {
    return api.post('/pace-program-improvements/', {improvement: improvement_id, pace_program: this.specInstanceId})
      .then((res) => {
        this.setState({
          improvementList: this.state.improvementList
            .map(d => d.id === improvement_id ? {
              ...d,
              selected: true,
              paceprogramimprovement_id: res.data.id
            } : d)
        })
      })
      .catch(() => addErrorAlert('Improvement was not added.'))
  }

  handlePaceProgramImprovementDeleteRequest = (improvement_id) => {
    let {paceprogramimprovement_id} = this.state.improvementList.find(d => d.id === improvement_id)
    if (!paceprogramimprovement_id) {
      console.warn("Unable to delete because we could not find a paceprogramimprovement id.");
      addErrorAlert("Unable to delete because we could not find a paceprogramimprovement id.");
      return;
    }

    return api.delete('/pace-program-improvements/' + paceprogramimprovement_id)
      .then((res) => {
        this.setState({
          improvementList: this.state.improvementList
            .map(d => d.id === improvement_id ? {...d, selected: null, paceprogramimprovement_id: null} : d)
        })
      })
      .catch(() => addErrorAlert("Improvement was not removed."))
  }

  handlePaceProgramImprovementCheckboxValueChange = (added, improvement_id) => {
    if (added) { // we checked the box, we wanted to add to add. Inverse is that we are removing the Improvement from program
      this.handlePaceProgramImprovementCreateRequest(improvement_id);
    } else {
      this.handlePaceProgramImprovementDeleteRequest(improvement_id)
    }
  }

  handleOpenProductModal = () => {
    let productsId = []
    this.state.specInstance.loan_products.map(p => {
      productsId = [...productsId, {
        productId: p.loan_product.id,
        joinId: p.id
      }]
    })

    this.setState({productsData: this.state.productsData.map((p) => ({
      ...p,
      funder_name: p.funder.name,
      selected: p.selected === undefined ? !!productsId.find(i => i.productId == p.id) : p.selected,
      joinId: productsId.find(i => i.productId == p.id)?.joinId
    }))}, this.setState({productModalOpen: true}))
  }

  handlePaceProgramProduct = (selected, id) => {
    let promise

    this.setState({productsData: this.state.productsData.map(d => ({...d, loading: d.id === +id}))})

    if (selected) {
      promise = () => api.post('/pace-program-loan-products/', {loan_product: +id, pace_program: this.specInstanceId})
    } else {
      let joinId = this.state.specInstance.loan_products.find(p => p.loan_product.id == +id)?.id + ''
      promise = () => api.delete('/pace-program-loan-products/' + joinId, {loan_product: +id})
    }

    promise()
    .then(() => {
      this.setState({productsData: this.state.productsData.map(d => ({
        ...d,
        loading: false,
        selected: d.id === +id ? selected : d.selected,
      }))})
    })
    .then(this.getData)
    .then(this.handleOpenProductModal)
  }

  handleCloseProductModal = () => {
    this.setState({productModalOpen: false}, this.getData)
  }


  changeMode = mode => {
    let displayedData; let displayedColumns;
    if (mode === 'communities') {
      displayedData = this.state.specInstance.districts
        .map(d => (
          {
            ...d,
            ...(d.district || {}),
            id: d.id,
            cities_included: d.all_child_districts_included,
            _html_cities_included: d.district.district_type === 'County' ?
              <Input type="checkbox"
                   onChange={(val) => this.handleDistrictPaceProgramPatchRequest(d.id, d.district.id, {all_child_districts_included: val})}
                   defaultChecked={d.all_child_districts_included}
              /> :
              null,
            _html_notes: (
              <div>
                <span
                  className="mr-3 icon has-text-primary"
                  onClick={() => {
                    this.setState({
                      exceptionModalOpen: true,
                      editingInstance: get(this, 'state.specInstance.districts', []).find(dist => dist.id === d.id) || {}
                    })
                  }}
                >
                <i className="far fa-edit"/></span>
                    {(d.district.exceptions || []).length ?
                      <span
                        className="has-text-primary has-text-weight-semibold">{(d.district.exceptions || []).length}</span> :
                      <span className="has-text-grey-lighter">--</span>}
                  </div>
            )
          }
        ))
    }
    if (mode === 'improvements') {
      // map existing improvements onto improvements listimprovementList[improvementIndex].selected = true;
      let {improvementList} = {...this.state};
      this.state.specInstance.improvements.filter(d => d.improvement).forEach(d => {
        let improvementIndex = improvementList.findIndex(item => item.id === d.improvement.id)
        if (improvementIndex < 0) {
          console.warn("no matching improvement found in the lineup for ", d.improvement.id, '--', d.improvement.name)
          return;
        }
        improvementList[improvementIndex].selected = true;
        improvementList[improvementIndex].paceprogramimprovement_id = d.id;

      })

      this.setState(improvementList)

    }

    // pull data again when leaving improvements so that it is updated.
    if (this.state.mode === 'improvements' && mode !== 'improvements' && this.state.changedImprovements) {
      this.getData()
        .then(() => this.setState({changedImprovements: false}))
    }
    this.setState({
      mode,
      displayedData
    })
  }


  renderDistrictSearchAndSelectElement = (result) => {
    let dpp = (this.state.specInstance.districts.find(d => d.district.id === result.id) || {})
    let dpp_id = dpp.id;
    let dpp__all_child_districts_included = dpp.all_child_districts_included;
    return (
      <div className="ss-result">
        <span
          className="icon"
          onClick={() => {
            if (result.added) {
              if (!dpp_id) return;
              this.handleDistrictPaceProgramDeleteRequest(dpp_id, result.id, false);
            } else {
              this.handleDistrictPaceProgramCreateRequest(result.id, result.district_type === 'County');
            }
          }}
        >
          {result.added ?
            <i className="fas fa-check-square has-text-success"/> :
            <i className="far fa-square"/>}
        </span>
        <span className="has-text-weight-semibold">{result.name}</span>
        <span>{result.district_type}</span>
        <span>{result.state}</span>
      </div>
    )
  }




  // this is sort of anti pattern, we basically repull all the data after update.
  // I couldn't get update to work correclty and I was running otu of time
  handleExceptionAdditionOrEdit = (val, exception_id = 0) => {
    let promise;
    if (exception_id) {
      promise = () => api.patch(`/district-exceptions/${exception_id}/`, {
        text_value: val
      })
    } else {
      const district_id = get(this.state, 'editingInstance.district.id')
      if (!district_id) {
        addErrorAlert("Unable to add exception because we couldn't match the district.");
        return;
      }

      promise = () => api.post('/district-exceptions/',{
        district: district_id,
        pace_program: this.state.specInstance.id,
        text_value: val
      })
    }

    toggleGlobalLoader(true);
    promise()
      .then((res) => {
        // start by updating the actual districts.

        let updatedEditingInstance = cloneDeep(this.state.editingInstance) // clone editing instance for reinsertion in specInstance object
        updatedEditingInstance.district.exceptions.push(res.data); // add the new note/exception
        let targetIdx = this.state.specInstance.districts.findIndex(d => d.id === this.state.editingInstance.id);

        if (targetIdx >= 0) {
          let updatedSpecInstance = cloneDeep(this.state.specInstance);
          updatedSpecInstance.districts[targetIdx] = updatedEditingInstance;

          this.setState({
            specInstance: updatedSpecInstance,
            editingInstance: updatedEditingInstance,
          })
        } else {
          throw new Error("Failed at matching targetIdx state update")
        }

      })
      .catch(() => {
        addErrorAlert(`The exception failed to ${exception_id ? 'update' : 'create'}.`)
      })
      .finally(() => toggleGlobalLoader(false))
  }


  handleExceptionDeletion = (exception_id) => {
    toggleGlobalLoader(true);

    api.delete(`/district-exceptions/${exception_id}/`)
      .then((res) => {
        let updatedEditingInstance = cloneDeep(this.state.editingInstance) // clone editing instance for reinsertion in specInstance object
        updatedEditingInstance.district.exceptions = updatedEditingInstance.district.exceptions.filter(d => d.id !== +exception_id); // add the new note/exception

        let targetIdx = this.state.specInstance.districts.findIndex(d => d.id === this.state.editingInstance.id);

        if (targetIdx >= 0) {
          let updatedSpecInstance = cloneDeep(this.state.specInstance);
          updatedSpecInstance.districts[targetIdx] = updatedEditingInstance;

          this.setState({
            specInstance: updatedSpecInstance,
            editingInstance: updatedEditingInstance,
          }, () => this.forceUpdate())
        } else {
          throw new Error("Failed at matching targetIdx state update")
        }
      })
      .catch(() => {
        addErrorAlert('The exception failed to delete.')
      })
      .finally(() => toggleGlobalLoader(false))
  }


  loadAndOpenMap = () => {
    toggleGlobalLoader(true);
    let district_ids = this.state.displayedData.map(d => get(d, 'district.id', 0))

    api.post('/district-geojson/', {district_ids})
      .then(res => {
        this.mapGeojson = res.data;
        this.setState({displayMap: true})
      })
      .catch(err => addErrorAlert("Something's not right. We had a problem getting the map data."))
      .finally(() => toggleGlobalLoader(false))
  };

  closeAndClearMap = () => {
    this.setState({displayMap: false})
  }


  renderFundersDisplay = () => {
    // console.log(this.state.specInstance)
    let {funders} = this.state.specInstance;

    if (!funders || !funders.length) {
      return <NoResultsBox/>
    }

    const funderCards = funders.filter(d => d.is_active).map((d,i) => {
      return (
        <div key={d.id} className="box">

          <h4 className="is-size-4 has-text-primary">{d.name}</h4>
          <p className="is-size-6 is-italic">{d.description}</p>

          {!!d.loan_products && !!d.loan_products.length &&

            <div className="mt-4">
              <h6 className="is-size-7 has-text-grey-light">Available Products</h6>
              {d.loan_products.map(l => {
                return (
                  <p>{l.name}</p>
                )
              })}

            </div>
          }

        </div>
      )
    });


    return (
      <>
        {funderCards}
        <div className="my-4 is-size-7 has-text-grey mx-auto">
          <p className="has-text-centered">Program Manager: if you see a funder that you have not approved for your program, kindly notify
            <a href='mailto:admin@cleanfi.com'> admin@cleanfi.com</a>, or contact the funder directly and ask them to qualify.</p>
        </div>
      </>
    )
  };



  render() {
    let {specInstance} = this.state;
    return (
      <AdminWrapper>
        {/* card containing the details of the spec instance */}
        <div className="section">
          <div className="container is-fullhd mx-6">
            <div className="box">
              <div className="level">
                <div className="level-left">
                  <div className="level-item">
                    <h2 className="title is-2">
                      {specInstance.name}
                    </h2>
                  </div>
                </div>
                <div className="level-left">
                  <div className="level-item">
                    <button
                      className='button is-link'
                      onClick={() => this.setState({editModalOpen: true})}
                    ><i className="fas fa-pencil"/>Edit
                    </button>
                  </div>
                  <div className="level-item">
                    <button
                      className='button is-danger'
                      onClick={() => this.setState({deleteModalOpen: true})}
                    >Delete
                    </button>
                  </div>
                  <div className="level-item">
                    <Link to="/admin/pace-programs/">
                      <button
                        className='button is-primary'
                      >Back
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
              <p className="has-text-weight-bold">{specInstance.description}</p>
              {[
                ...this.editSpecInstanceInputs
                  .filter(d => !['name', 'description', 'annual_fee'].includes(d.dataKey))
                  .filter(d => !d.dataKey.includes('program_fee'))
              ]
                .map(d => (
                  <p>
                    <span className="mr-3">{d.label}:</span>
                    <span>
                      {displaySummaryData(specInstance[d.dataKey], d.dataKey, d.formatter)}
                      {!!d.otherInputs && !!d.otherInputs.length && d.otherInputs.map(o => (
                        <span>/ {displaySummaryData(specInstance[o.dataKey], o.dataKey, d.formatter)}</span>
                      ))}
                    </span>
                  </p>
                ))}
              <p>
                <span className="mr-3">Program Fee:</span>
                <span>
                  {specInstance.program_fee_desc}
                </span>
              </p>
              <p>
                <span className="mr-3">Annual Fee:</span>
                <span>
                  {specInstance.annual_fee_desc}
                </span>
              </p>
            </div>
          </div>
        </div>
        <div className="section pt-2">
          <div className="container is-fullhd mx-6">
            <div className="tabs is-medium">
              <ul>
                <li
                  className={this.state.mode === 'communities' ? 'is-active' : ''}
                  onClick={() => this.changeMode('communities')}
                >
                  <a>
                    <span className="icon is-small">
                      <i className="fas fa-map-pin"
                         aria-hidden="true"/></span>
                    <span>Communities</span>
                  </a>
                </li>
                <li
                  className={this.state.mode === 'improvements' ? 'is-active' : ''}
                  onClick={() => this.changeMode('improvements')}
                >
                  <a>
                    <span className="icon is-small">
                      <i className="fas fa-building"
                         aria-hidden="true"/></span>
                    <span>Improvements</span>
                  </a>
                </li>
                <li
                  className={this.state.mode === 'funders' ? 'is-active' : ''}
                  onClick={() => this.changeMode('funders')}
                >
                  <a>
                    <span className="icon is-small">
                      <i className="fas fa-piggy-bank"
                         aria-hidden="true"/></span>
                    <span>Funders</span>
                  </a>
                </li>
              </ul>
            </div>

            {/* DISTRICTS CODE */}
            {this.state.mode === 'communities' &&
            <>
              <div className="level">
                <div className="level-left">
                  <div className="level-item">
                    <h4 className="title is-4">Manage Communities</h4>
                  </div>
                </div>
                <div className="level-right">
                  <div className="level-item">
                    <button
                      className='button is-link'
                      onClick={() => this.setState({addDistrictPaceProgramModalOpen: true})}
                    >+ Add Communities</button>
                  </div>
                  <div className="level-item">
                    <button
                      className='button is-info'
                      onClick={this.loadAndOpenMap}
                    >
                        <i className="far fa-map mr-2"/>
                      View Map
                    </button>
                  </div>

                </div>
              </div>
              <PaginatedTable
                className="is-fullwidth is-hoverable"
                data={this.state.displayedData}
                columns={['name', 'district_type', 'state', 'cities_included', 'notes']}
                pullLimit={this.state.dataPullLimit}
                handleLimitChange={this.handleLimitChange}
                pullOffset={this.state.dataPullOffset}
                handleOffsetChange={this.handleOffsetChange}
                showSortBar={false}
                showPageNavigators={false}
                actions={[
                  {
                    name: 'Delete',
                    elem: (<span className="icon has-text-danger">
                        <i className="fas fa-minus-square"/>
                      </span>),
                    action: (data) => this.setState({
                      deleteDistrictPaceProgramModalOpen: true,
                      editingInstance: {...data}
                    })
                  }
                ]}
              />
            </>
            }


            {/* IMPROVEMENTS CODE */}
            {this.state.mode === 'improvements' &&
            <>
              <div className="level">
                <div className="level-left">
                  <div className="level-item">
                    <h4 className="title is-4">Manage Improvements</h4>
                  </div>
                </div>
                <div className="level-right">
                  <div className="level-item">
                    <div className="buttons">
                      <button
                        disabled
                        className='button is-link'
                      >Add Improvements Below
                      </button>
                      {this.props.tokenData.admin &&
                      <Link to="/admin/improvements">
                        <button
                          className='button'
                        >+ Create New Improvement
                        </button>
                      </Link>
                      }
                    </div>
                  </div>
                </div>
              </div>
              <SelectByCategory
                data={this.state.improvementList}
                onOptionValueChange={this.handlePaceProgramImprovementCheckboxValueChange}
              />
            </>
            }

            {/* FUNDERS CODE */}
            {this.state.mode === 'funders' &&
            <>
              <div className="level">
                <div className="level-left">
                  <div className="level-item">
                    <h4 className="title is-4">Funders currently servicing this program</h4>
                  </div>
                </div>
                <div className="level-right">
                  <button className='button is-link' onClick={this.handleOpenProductModal}>+ Add Products</button>
                </div>
              </div>

              {this.renderFundersDisplay()}
            </>

            }


          </div>
        </div>

        <FormModal
          title={'Edit ' + this.state.specInstance.name}
          visible={this.state.editModalOpen}
          inputs={this.populateSpecInstanceInputsWithValues()}
          disableAutocomplete
          onSubmit={this.handleUpdateRequest}
          onCancel={() => this.setState({editModalOpen: false, editingInstance: null})}
        />

        <ConfirmModal
          type="warning"
          visible={this.state.deleteModalOpen}
          prompt={!!this.state.specInstance && `Are you sure you want to deactivate ${this.state.specInstance.name}?`}
          onCancel={() => this.setState({deleteModalOpen: false, editingInstance: null})}
          onAccept={this.handleDeleteRequest}
        />

        {/* Delete pace program district */}
        <ConfirmModal
          type="warning"
          visible={this.state.deleteDistrictPaceProgramModalOpen}
          prompt={!!this.state.editingInstance && `Are you sure you want to remove the ${this.state.editingInstance.district_type} ${this.state.editingInstance.name} from this program?`}
          onCancel={() => this.setState({deleteDistrictPaceProgramModalOpen: false, editingInstance: null})}
          onAccept={() => this.handleDistrictPaceProgramDeleteRequest(this.state.editingInstance.id)}
        />

        {/*  Search for an add districts to pace program  */}
        <SearchAndSelectModal
          title={`Add Communities to ${this.state.specInstance.name}`}
          visible={this.state.addDistrictPaceProgramModalOpen}
          onCancel={() => this.setState({addDistrictPaceProgramModalOpen: false},
            () => this.getData().then(() => this.changeMode('communities')))}
          handleSearch={(val) => {
            if (val.length > 2) {
              this.getDistrictsForAddition(val);
            }
          }}
          results={this.state.districtAdditionSearchResults}
          renderResultElement={this.renderDistrictSearchAndSelectElement}
        />


        {/* Note that we force mount and unmount this. Inneficient and could be significantly improved. */}
        {this.state.displayMap &&
        <BaseModal
          visible
          cardStyle={{width: 1040, height: 840,  display: 'flex', justifyContent: 'center'}}
        >
          <MapFrame geojsonData={this.mapGeojson}/>
          <button onClick={this.closeAndClearMap} className="modal-close is-large" aria-label="close"/>
        </BaseModal>
        }

        <ItemTextEditModal
          visible={this.state.exceptionModalOpen}
          title={'Edit Exceptions for ' + (get(this.state, 'editingInstance.district', {})).name}
          onCancel={() => this.setState({exceptionModalOpen: false, editingInstance: {}})}
          items={get(this, 'state.editingInstance.district', {}).exceptions || []}
          onAdd={(val) => this.handleExceptionAdditionOrEdit(val)}
          onDelete={this.handleExceptionDeletion}
        />

        {/* ADD/DELETE PRODUCTS TO PACE PROGRAM */}
        <BaseModal
          visible={this.state.productModalOpen}
          cardStyle={{width: 640, height: 800,  display: 'flex', justifyContent: 'center'}}
        >
          <h5 className="title is-5">Link Products to {this.state.specInstance.name}</h5>
          <SelectByCategory
            data={this.state.productsData}
            categoryKey="funder_name"
            onOptionValueChange={this.handlePaceProgramProduct}
          />
          <button className='button is-primary' onClick={this.handleCloseProductModal}>Close</button>
        </BaseModal>

      </AdminWrapper>
    )
  }

}


const mapStateToProps = state => ({
  states: state.states.data,
  tokenData: state.user.decodedTokenData || {},
})

export default connect(mapStateToProps)(PaceProgramSpecScreen)
